
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"evaluation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Evaluation"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"elementId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"elementType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"attemptId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"studentScopeURN"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":99}};
    doc.loc.source = {"body":"fragment evaluation on Evaluation {\n  id\n  elementId\n  elementType\n  attemptId\n  studentScopeURN\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    
